import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const field = "w-full bg-white border border-[#D8CEBE] rounded-md px-4 py-3 text-[#2A2825] font-body outline-none focus:border-[#A9724E] transition-colors";

export function TrialSignupForm({ compact = false }) {
  const [form, setForm] = useState({ name: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.email.trim()) { toast.error("Please add your email."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/trial-signup`, { name: form.name.trim(), email: form.email.trim() });
      setDone(true);
      toast.success("Check your inbox — your 7-day taste is on the way.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  if (done) {
    return <p data-testid="trial-success" className="font-serif-display italic text-xl md:text-2xl text-[#A9724E]">You're in. Watch your inbox for day one. ✦</p>;
  }
  return (
    <form onSubmit={submit} data-testid="trial-form" className={compact ? "flex flex-col sm:flex-row gap-3 max-w-xl" : "space-y-3 max-w-md"}>
      <input data-testid="trial-name" className={field} placeholder="First name (optional)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
      <input data-testid="trial-email" type="email" required className={field} placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
      <button type="submit" disabled={loading} data-testid="trial-submit"
        className="shrink-0 rounded-full bg-[#A9724E] hover:bg-[#925C3B] text-[#F4EFE6] px-7 py-3 text-sm tracking-wide transition-colors duration-500 disabled:opacity-50 inline-flex items-center justify-center gap-2">
        <Sparkles className="w-4 h-4" strokeWidth={1.5} />{loading ? "Starting…" : "Start my free 7-day taste"}
      </button>
    </form>
  );
}
